var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.loginModal'] = (function () {
    'use strict';

    const onlineBankingValue = 'online-banking';
    const creditCardValue = 'personal-credit-card';
    const creditCardUrl = 'https://dxonline.pscu.com/wps/portal/accesspoint/login?req=G2Kgqzs__HfrG0VgsF9ouQ';

    const initialize = (container) => {
        const accountSelect = container.querySelector('#header-login-account');
        const onlineBankingLogin = container.querySelector('#online-banking-login');

        if (!(accountSelect instanceof HTMLSelectElement) || !(onlineBankingLogin instanceof HTMLElement)) {
            return;
        }

        const collapse = bootstrap.Collapse.getOrCreateInstance(onlineBankingLogin, { toggle: false });

        accountSelect.addEventListener('change', () => {
            if (accountSelect.value === onlineBankingValue) {
                collapse.show();
                return;
            }

            collapse.hide();

            if (accountSelect.value === creditCardValue) {
                window.open(creditCardUrl, '_blank', 'noopener');
            }
        });
    };

    return {
        initialize
    };
})();